/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlMonitorFallbackPreset = {
    Escalate: 'ESCALATE',
    EscalateContain: 'ESCALATE_CONTAIN',
    Close: 'CLOSE'
} as const;
export type ControlMonitorFallbackPreset = typeof ControlMonitorFallbackPreset[keyof typeof ControlMonitorFallbackPreset];


export function ControlMonitorFallbackPresetFromJSON(json: any): ControlMonitorFallbackPreset {
    return ControlMonitorFallbackPresetFromJSONTyped(json, false);
}

export function ControlMonitorFallbackPresetFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlMonitorFallbackPreset {
    return json as ControlMonitorFallbackPreset;
}

export function ControlMonitorFallbackPresetToJSON(value?: ControlMonitorFallbackPreset | null): any {
    return value as any;
}

